<template>
  <div id="AppNavbar" class="fixed-top">
    <b-row no-gutters>
      <router-link v-if="benutzer && benutzer.funktionen.sicherheit === 1" to="/" class="main-icon-link bg-success text-white col py-2">
        <font-awesome-icon icon="home"/>
        <font-awesome-icon v-if="newMessages" icon="envelope" variant="warning" class="text-warning iconClass"/>
      </router-link>

      <router-link v-if="benutzer && benutzer.funktionen.kommunikation === 1" to="/kommunikation" class="main-icon-link bg-warning text-white col py-2">
        <font-awesome-icon icon="address-book" />
      </router-link>

      <router-link v-if="benutzer && benutzer.funktionen.unterhaltung === 1" to="/unterhaltung" class="main-icon-link bg-danger text-white col py-2">
        <font-awesome-icon icon="photo-video" />
      </router-link>

      <router-link v-if="benutzer && benutzer.funktionen.gesundheit === 1" to="/gesundheit" class="main-icon-link bg-primary text-white col py-2">
        <img id="digiRollIcon" src="@/assets/icons/Rollator_Icon_white.png" width="110" height="61"/>
        <!-- <font-awesome-icon icon="medkit" class="main-icon"/> -->
      </router-link>
      <router-link v-if="benutzer && benutzer.funktionen.einstellungen === 1" to="/profil" class="main-icon-link bg-secondary text-white col py-2">
        <font-awesome-icon icon="cog" class="main-icon"/>
      </router-link>
      <router-link v-if="benutzer && benutzer.admin === 1" to="/admin" class="main-icon-link bg-dark text-white col py-2">
        <font-awesome-icon icon="users-cog" class="main-icon"/>
      </router-link>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppNavbar',
  computed: {
    ...mapGetters(['benutzer', 'messages']),
    newMessages () {
      return (this.messages.filter(m => m.gelesen === 0)).length != 0
    }
  }
}
</script>

<style scoped>
  #AppNavbar {
    font-size: 5em;
  }

  .main-icon-link:hover {
    text-decoration: none;
  }

  .iconClass {
    height: 35%;
    position: absolute;
    bottom: 15%;
    right: 10%;
  }

  /* .grow {
    transition: all .2s ease-in-out;
  }

  .grow:hover {
    transform: scale(1.1);
  } */


  @media screen and (max-width: 576px) {
    #AppNavbar {
      font-size: 2em;
    }

    #digiRollIcon {
      width: 40px;
      height: 22.3px;
    }
  }

  @media screen and (min-width: 577px) and (max-width: 992px) {
    #AppNavbar {
      font-size: 3.5em;
    }

    #digiRollIcon {
      width: 80px;
      height: 44,5px;
    }
  }
</style>
